import { useQuery, useQueryClient } from '@tanstack/react-query'
import { favourites, isMissing } from '@/api/proposed'
import { useAuth } from './auth'
import { useLocal } from './local'
import { personalStore } from './personal'
import { session } from './session'

const local = personalStore<number[]>('favourites', [])

/** Favourite stations: on the account once the API has D12, on this device until then. */
export function useFavourites() {
  const { user } = useAuth()
  const qc = useQueryClient()
  const key = ['favourites', user?.id ?? 'guest']
  const q = useQuery({ queryKey: key, queryFn: favourites.list, enabled: !!user, retry: false, staleTime: 5 * 60_000 })
  const onDevice = useLocal(local)
  const synced = !!user && !!q.data && !q.error
  const ids = new Set(synced ? q.data!.station_ids : onDevice)

  const toggle = async (stationId: number) => {
    const revision = session.revision()
    const on = !ids.has(stationId)
    if (synced) {
      qc.setQueryData(key, { station_ids: on ? [...ids, stationId] : [...ids].filter((x) => x !== stationId) })
      try {
        await (on ? favourites.add(stationId) : favourites.remove(stationId))
      } catch (e) {
        if (revision !== session.revision()) return on
        if (!isMissing(e)) qc.invalidateQueries({ queryKey: ['favourites'] })
      }
    } else {
      local.set(on ? [...onDevice, stationId] : onDevice.filter((x) => x !== stationId))
    }
    return on
  }
  return { ids, toggle, synced }
}
